import React from 'react';
import Profissional from '../../../components/Profissionais/Profissionais';
import MarisaImg from '../../../assets/profissionais/Marisa.png';

function Marisa() {
  return (
    <Profissional 
      nome="Marisa Mathes"
      customClass="profissional-marisa"
      cargo="Orientadora Educacional, Psicopedagoga e Contadora de Histórias"
      imagem={MarisaImg}
      descricao={
        <>
          <div className="profissional-descricao">
            <p>Sou a professora Marisa Mathes e tive a honra de atuar como Bibliotecária do Colégio Ágape da qual recebe o meu nome: Biblioteca Escolar Ágape Professora Marisa Mathes.</p>

            <p>Minha função foi fundamental para promover o acesso à informação e à cultura dentro da instituição. Como bibliotecária, trabalhei para organizar, preservar e disseminar o acervo da biblioteca, atendendo às necessidades de alunos, pais, professores e funcionários.</p>

            <p>Busquei sempre criar um ambiente acolhedor e inspirador, onde todos pudessem explorar as infinitas possibilidades do conhecimento. </p>

            <p>Foi uma imensa satisfação poder contribuir para a educação e o desenvolvimento dos estudantes do Colégio Ágape de Caldas Novas durante 12 anos. Além do mais, tenho experiência em Orientação Educacional e em Psicopedagogia Clínica e Institucional.</p>

            <p className='text-highlight'>Orientadora Educacional</p>

            <p>É com grande dedicação que exerço minha função, voltada para o apoio a famílias, crianças e educadores oferecendo suporte que transcendem o contexto escolar e enfocam no desenvolvimento integral das crianças.</p>
            
            <p>Acredito que cada família possui uma história única, e por isso busco compreender as necessidades e particularidades para implementar estratégias personalizadas que favoreçam o crescimento individual da criança.</p>

            <p>Adicionalmente, promovo oficinas e atividades que estimulam a participação dos pais, fortalecendo os laços familiares e aprimorando a comunicação entre todos os envolvidos.
            Estou convencida que a educação é um esforço colaborativo e trabalho para envolver partes interessadas nesse processo. 
            </p>

            <p className='text-highlight'>Psicopedagogia</p>
            
            <p>Como psicopedagoga na Clínica Família Singular, ocupo uma função que integra a psicologia e a pedagogia com o objetivo de promover o desenvolvimento integral do indivíduo, especialmente no que se refere ao aprendizado e às interações sociais.</p>

            <p>Na minha atuação clínica, trabalho diretamente com crianças, adolescentes e suas famílias, avaliando e intervindo em questões que podem interferir no processo de aprendizagem e desenvolvimento emocional.</p>
            
            <p>Utilizo uma abordagem centrada no indivíduo, buscando entender suas necessidades particulares e contextos familiares, a fim de elaborar estratégias personalizadas que favoreçam o aprendizado e a autoestima.</p>

            <p>Além da atuação clínica, também desempenho um papel institucional, colaborando com escolas e outras instituições educacionais. Nesse contexto, realizo assessorias e oficinas, proporcionando orientações a educadores e pais sobre práticas pedagógicas inclusivas e intervenções que visam facilitar o ensino-aprendizagem. Acreditamos que a parceria entre a clínica e a escola é fundamental para a construção de um ambiente que promova o bem-estar e o desenvolvimento integral das crianças. </p>

            <p>Meu trabalho na Clínica Família Singular é pautado pela ética, empatia e respeito à singularidade de cada indivíduo, sempre buscando promover uma educação mais equitativa e acessível. Acredito que, por meio da psicopedagogia, é possível transformar desafios em oportunidades de crescimento e aprendizado, tanto no âmbito familiar quanto escolar. </p>

            <p>Estou à disposição para contribuir no desenvolvimento de práticas que favoreçam o aprendizado e a saúde emocional, visando o bem-estar de todos os envolvidos no processo educacional.</p>

            <p className='text-highlight'>Contadora de Histórias</p>

            <p>Estou super animada para ser a contadora de histórias da Clínica Família Singular! Acredito que cada história tem o poder de nos conectar, ensinar e encantar. Vou trazer contos cheios de magia e aprendizados que vão fazer a nossa imaginação voar! Vamos juntos embarcar nessa aventura literária? </p>

            <p>As sessões vão ser um espaço para a gente se divertir, relaxar e, claro, criar laços. Espero todo mundo por aqui para contar, ouvir e compartilhar histórias incríveis!</p>
          </div>
        </>
      }
    />
  );
}

export default Marisa;
